import React from 'react';
import { withRouter } from 'react-router-dom';

import { pushPageView } from '../analytics';

/**
 * Reports every route change to GTM as a `spa_pageview` event.
 *
 * Only the pathname is compared, so a changing query string does not report a
 * second view of the same page. Query strings are stripped before anything is
 * sent anyway, see analytics.js.
 */
class Analytics extends React.Component {
	componentDidMount() {
		pushPageView(this.props.location);
	}

	componentDidUpdate(prevProps) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			pushPageView(this.props.location);
		}
	}

	render() {
		return this.props.children;
	}
}

export default withRouter(Analytics);



// WEBPACK FOOTER //
// ./src/components/Analytics.js